import { Injectable } from '@angular/core';
import { FiltersComponentInterface, FiltersTypeEnum, IFilterComboComponent } from 'world-archery-lib';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { FiltersAbstractService } from '../../../../common-page-components/classes/filters-abstract-service';
import { TextFilter } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FiltersInterpretationService extends FiltersAbstractService {

  textFilter = new TextFilter('rbfilter');

  filtersType: FiltersComponentInterface = [
    this.textFilter.filterInfo,

    {
      options: {
        type: FiltersTypeEnum.RangeDateSimpleFilter,
        hideFilter:true,
        date_from: {
          type: FiltersTypeEnum.DateFilter,
          date_format: 'dd MMMM yyyy',
          placeholder: 'From:',
          date_subject: new BehaviorSubject<any>(this.getDateDefault()),
          id: 'rbidatefrom'
        } as any,
        date_to: {
          type: FiltersTypeEnum.DateFilter,
          date_format: 'dd MMMM yyyy',

          placeholder: 'To:',
          date_subject: new BehaviorSubject<any>({}),
          id: 'rbidateto'
        } as any
      }
    },
    /*  Not provided for api yet

    {
       options: {
         type: FiltersTypeEnum.ComboBox,

         name_filter: 'Type',
         options_subject: new BehaviorSubject<Array<any>>([
           { name: 'Bylaw' },
           { name: 'Interpretation' }
         ]),
         option_name_property: 'name',
         options_selected_subject: new BehaviorSubject<any>({
           name: 'Bylaw'
         } as any),
         id: 'rbitype'
       } as IFilterComboComponent
     },*/
  ];

  constructor() {
    super();
   }
  /**
   * {@inheritdoc}
   *
   * @returns {[]}
   * @memberof FiltersInterpretationService
   */
  getDataStreamWithFilters() {
    return combineLatest([this.orderValue, this.textFilter.data().pipe(distinctUntilChanged(), debounceTime(300)),
    (this.filtersType[1].options as any).date_from.date_subject.asObservable(),
    (this.filtersType[1].options as any).date_to.date_subject.asObservable()]);
  }


  /**
   * Get default date for filters.
   *
   * @return Date
   *   From now.
   */
  getDateDefault() {
    const date = new Date(), y = date.getFullYear(), m = date.getMonth();
    return { value: date };
  }

  generateDefaultValues(): void {
    return;
  }
}
